import type { ReactElement } from 'react';
import { parseDocument } from 'htmlparser2';
import {
  domToReact,
  type DOMNode,
  type HTMLReactParserOptions,
} from 'html-react-parser';
import { sanitizeHTML } from './sanitizeHTML';

export type ParseHtmlOptions = HTMLReactParserOptions;

export function parseHtml(
  html: string,
  options?: ParseHtmlOptions,
): string | ReactElement | Array<ReactElement> {
  const sanitized = sanitizeHTML(html);
  const doc = parseDocument(sanitized);
  return domToReact(doc.children as Array<DOMNode>, options);
}
